import React from 'react';
import './App.css';
import Table from './Table/Table'

function App() {
  return (
    <div className="App">
    <div className='titleText'>Tic toc toe</div>
    <Table/>
    </div>
  );
}

export default App;
